import { useMutation } from 'react-query';

import { updateProjectEmployeePopulation } from 'shared/api/projects/http';

const useMutateUpdateProjectEmployeePopulation = (options = undefined) =>
  useMutation(({ id, employeePopulation }) => updateProjectEmployeePopulation(id, employeePopulation), options);

export default useMutateUpdateProjectEmployeePopulation;
